module.exports = __webpack_public_path__ + "static/media/guide.75b73b24.jpg";